import * as React from 'react';
import cx from 'classnames';
import Label from './components/Label';
import Text from './components/Text';

interface PageBodyProps {
  template?: undefined | 'table';
  className?: string;
  style?: any;
  children: React.ReactNode;
}

const PageBody = ({ className, style, children, ...props }: PageBodyProps) => {
  if (props.template === 'table') {
    return (
      <div className={cx(['br-pagebody', 'mt-0', className])} style={style}>
        <div className="card bd-0 shadow-base">{children}</div>
      </div>
    );
  }

  return (
    <div className={cx(['br-pagebody', 'mt-0', className])} style={style}>
      {/* <div className="br-section-wrapper pd-20">{children}</div> */}
      {children}
    </div>
  );
};

(PageBody as any).Label = Label;
(PageBody as any).Text = Text;

export default PageBody;
